import React from 'react';

export default function LogLine(props) {
  const { message } = props || {};
  const { data, date } = message || {};
  const [line] = data || [];
  if (typeof line !== 'string') {
    return null;
  }
  const options = {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
  };
  return (
    <tr key={`tr-${date}-${line.substring(10)}`}>
      <td>{new Intl.DateTimeFormat('en-US', options).format(new Date(date))}</td>
      <td>{line.substring(0, 100)}</td>
    </tr>
  );
}
